import { FelaCSS, spacing } from '@bridebook/ui';

interface IStyles {
  pill: FelaCSS;
}

const styles: IStyles = {
  pill: {
    gap: spacing[2],
    cursor: 'pointer',
    // @ts-expect-error text-wrap is a valid css property
    textWrap: 'wrap',
    paddingVertical: '6px', // needs to be 6 so the pill is 30px high while allowing the text to wrap
    height: 'auto',
  },
};

export default styles;
